import { createAsyncThunk } from 'app/store/utils';
import axios from 'axios';
import { FetchIntercomConfigResponse } from 'types/api.types';
import { getIntercomConfigLink } from 'app/store/Intercom/selectors';

export const fetchIntercomConfigEffect = createAsyncThunk(
  'intercom/fetchConfig',
  async (_, { getState }) => {
    const link = getIntercomConfigLink(getState());
    if (!link) {
      throw new Error('Intercom config link not found');
    }

    const response = await axios.get<FetchIntercomConfigResponse>(link.href, {
      withCredentials: true,
    });

    return {
      intercomConfig: response.data.response.intercomConfig.item,
      userHash: response.data.response.userHash?.item,
    };
  }
);
